import React from 'react'
import { useIntl } from 'react-intl'
import LabeledDropdown from '../common/form-components/labeled-dropdown/LabeledDropdown'

const SubstitutionsSelector = ({
  disabled = false,
  idLabel = 'substitutions',
  value,
  onChange,
}) => {
  const { formatMessage: msg } = useIntl()

  const options = [
    { value: 'include', label: msg({ id: 'include' }) },
    { value: 'exclude', label: msg({ id: 'exclude' }) },
    { value: 'exclusive', label: msg({ id: 'exclusive' }) },
  ]

  return (
    <LabeledDropdown
      disabled={disabled}
      idLabel={idLabel}
      options={options}
      optionLabel="label"
      optionValue="value"
      value={value}
      onChange={onChange}
      required
    />
  )
}

export default SubstitutionsSelector
